<div class="team-publish-container">
  <div class="summary wizard-container">
    <div [innerHTML]="documentationUrl" *ngIf="!fetchingDoc"></div>
  </div>
</div>
